import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


export abstract class BaseService<T> {

  constructor(public http: HttpClient) { }

  public abstract getPathModule(): string;

  public getById(id: number | string): Observable<T> {
    return this.http.get<T>(this.baseUrl + '/' + id, { headers: this.headers });
  }

  public findAll(): Observable<T[]> {
    return this.http.get<T[]>(this.baseUrl, { headers: this.headers });
  }

  public getListAll(id: number): Observable<T[]> {
    return this.http.get<T[]>(this.baseUrl + '/list/' + id, { headers: this.headers });
  }

  public getListSearch(obj: T = null): Observable<T[]> {
    return this.http.post<T[]>(this.baseUrl + '/search', obj, { headers: this.headers });
  }

  public create(obj: T): Observable<T> {
    return this.http.post<T>(this.baseUrl, obj, { headers: this.headers });
  }

  public update(obj: object, id: number | string = null): Observable<T> {
    const url = this.baseUrl + ( id? ('/' + id): '');
    return this.http.put<T>(url , obj, { headers: this.headers });
  }

  public delete(id: number | string): Observable<any> {
    return this.http.delete(this.baseUrl + '/' + id, { headers: this.headers });
  }

  public deleteAll(ids: number[]): Observable<any> {
    const params = '?ids=' + ids.join('&ids=');
    return this.http.delete(this.baseUrl + '/all' + params, { headers: this.headers });
  }
  
  public getListCombos(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list', { headers: this.headers });
  }

  public get baseUrl(): string {
    return environment.apiUrl + this.getPathModule();
  }

  public get headers(): HttpHeaders {
    let headers = new HttpHeaders();
    headers = headers.append("Content-Type", 'application/json');
    return headers;
  }
}
